// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { SettingsSectionMarker } from "..";
import * as React from "react";
import { Field, Form } from "react-final-form";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { Dispatch, compose } from "redux";

import { Alert, Checkbox, Display, Heading, PromoBannerV2, Text } from "@livechat/design-system-react-components";

import { FixedSaveBar, SaveBarMode } from "components/form";
import { SaveBarSpaceEquivalent } from "components/form/SaveBar";
import Block from "components/layout/Block";
import Flex from "components/layout/Flex";
import { StyledLink } from "components/links/StyledLink";
import { HelpCenter } from "constants/help-center";
import { Right } from "constants/right";
import { SettingsSection } from "constants/settings/sections";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { IStoreState } from "interfaces/storeState";
import { AgentFormSectionId } from "routes/agents/agent-form/constants";
import { AutomationsRoutes } from "routes/automations/constants";
import { ITeam, ITeamSettingsNotifications, selectCurrentAgentTeams } from "store/entities/teams";
import { getCurrentAgentId, hasRight } from "store/features/session";
import { history } from "store/history";
import { SettingsViewActions, getSelectedTeam, isUpdatingTeamNotifications } from "store/views/settings";

import TeamSelection from "../TeamSelection";
import SettingsViewContainer from "../ViewContainer";
import { ContentWrapper, PageWrapper } from "../styled";

interface IStateProps {
  teams: ITeam[];
  selectedTeam: ITeam;
  canManageNotifications: boolean;
  updatingTeamNotifications: boolean;
  currentAgentId: string;
  history: RouteComponentProps["history"];
}

interface IDispatchProps {
  setTeamId(teamId: string): void;
  onSubmit(teamId: string, settings: ITeamSettingsNotifications): void;
}

interface IProps extends IStateProps, IDispatchProps {}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
const fillDefaultTemplatesIfNeeded = (settings: any) => ({
  ...settings,
});

class Notifications extends React.PureComponent<IProps> {
  templateNewTicketTextRef: React.RefObject<HTMLTextAreaElement> = React.createRef<HTMLTextAreaElement>();
  templateRatingRequestTextRef: React.RefObject<HTMLTextAreaElement> = React.createRef<HTMLTextAreaElement>();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount() {
    trackEngagement("Settings: Email notifications section opened", EventPlace.Settings);
  }

  getMode = (pristine: boolean): SaveBarMode => {
    if (this.props.updatingTeamNotifications) {
      return SaveBarMode.Saving;
    }

    if (!pristine) {
      return SaveBarMode.OfferSave;
    }

    return SaveBarMode.Hidden;
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleTeamSelected = (selectedTeamId: string) => {
    this.props.setTeamId(selectedTeamId);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleSubmit = (settings: ITeamSettingsNotifications) => {
    const settingsWithTemplates = fillDefaultTemplatesIfNeeded(settings);
    this.props.onSubmit(this.props.selectedTeam.id, settingsWithTemplates);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleTryNotificationsClick = () => {
    const { history } = this.props;
    history.push(`/agents/${this.props.currentAgentId}/edit/#${AgentFormSectionId.BrowserNotifications}`);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { teams, selectedTeam, canManageNotifications } = this.props;

    return (
      <SettingsViewContainer title="Email notifications">
        <SettingsSectionMarker section={SettingsSection.Notifications} />
        <PageWrapper>
          <TeamSelection teams={teams} selectedTeamId={selectedTeam.id} onTeamSelected={this.handleTeamSelected} />
          <ContentWrapper>
            <Block marginBottom="37px">
              <Text>
                Enable email notifications for ticket updates or account changes. These notifications are set up for the
                selected team and will be sent when no agent is assigned to a ticket.
              </Text>
            </Block>
            {!canManageNotifications && (
              <Block maxWidth="800px" marginTop="24px" marginBottom="24px">
                <Alert kind="info">
                  You are not allowed to make changes.{" "}
                  <StyledLink
                    kind="link-light"
                    to="/agents"
                    onClick={() => trackEngagement("Email notifications: Contact any admin", EventPlace.Settings)}
                  >
                    Contact one of your Admins
                  </StyledLink>{" "}
                  to do so.
                </Alert>
              </Block>
            )}
            <Form
              onSubmit={this.handleSubmit}
              initialValues={selectedTeam.settings}
              // FIXME: Fix this the next time the file is edited.
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              render={({ form, handleSubmit, pristine }: any) => {
                const resetForm = form.reset;
                return (
                  <form onSubmit={handleSubmit}>
                    <Block>
                      <fieldset>
                        <Heading size="xs" as="h2">
                          Notifications sent to all agents from the team:
                        </Heading>
                        <Block marginBottom="20px">
                          <Field
                            name="notifyTeamAboutRequestersActivity"
                            type="checkbox"
                            disabled={!canManageNotifications}
                            // FIXME: Fix this the next time the file is edited.
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            render={({ input }: any) => (
                              <Checkbox
                                description="Notify agents when a requester creates a ticket or sends a new message."
                                {...input}
                              >
                                New ticket update
                              </Checkbox>
                            )}
                          />
                        </Block>

                        <Block marginBottom="20px">
                          <Field
                            name="notifyTeamAboutAssignedTicket"
                            type="checkbox"
                            disabled={!canManageNotifications}
                            // FIXME: Fix this the next time the file is edited.
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            render={({ input }: any) => (
                              <Checkbox description="Notify agents when their team is assigned to a ticket." {...input}>
                                New Team assigned
                              </Checkbox>
                            )}
                          />
                        </Block>
                      </fieldset>
                    </Block>

                    <PromoBannerV2
                      primaryButton={{
                        label: "Try it out",
                        handleClick: this.handleTryNotificationsClick,
                        kind: "high-contrast",
                      }}
                      secondaryButton={{
                        label: "Learn more",
                        handleClick: () => window.open(HelpCenter.ENABLE_BROWSER_NOTIFICATIONS, "_blank"),
                        kind: "text",
                      }}
                      css={{ maxWidth: "800px" }}
                    >
                      <Flex column css={{ "& > p": { margin: 0 } }}>
                        <Display>Enable browser notifications</Display>
                        <Text>Try notifications in your browser to stay on top of all ticket updates.</Text>
                      </Flex>
                    </PromoBannerV2>

                    <Block marginBottom="40px" />

                    <fieldset>
                      <Heading size="xs" as="h2">
                        Notifications sent to requesters:
                      </Heading>
                      <Text>
                        You can find these settings in the{" "}
                        <StyledLink kind="link-light" to={AutomationsRoutes.Rules}>
                          rules
                        </StyledLink>{" "}
                        in the Automations section.
                      </Text>
                    </fieldset>
                    <SaveBarSpaceEquivalent />
                    <FixedSaveBar
                      mode={this.getMode(pristine)}
                      onSave={handleSubmit}
                      saveDisabled={false}
                      cancelLabel="Discard"
                      onCancel={resetForm}
                    />
                  </form>
                );
              }}
            />
          </ContentWrapper>
        </PageWrapper>
      </SettingsViewContainer>
    );
  }
}

const mapStateToProps = (state: IStoreState): IStateProps => ({
  teams: selectCurrentAgentTeams(state),
  // @ts-expect-error TS(2322)
  selectedTeam: getSelectedTeam(state),
  canManageNotifications: hasRight(state, Right.ManageNotifications),
  updatingTeamNotifications: isUpdatingTeamNotifications(state),
  // @ts-expect-error TS(2322)
  currentAgentId: getCurrentAgentId(state),
  history,
});

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  // @ts-expect-error TS(2345)
  setTeamId: (teamId: string) => dispatch(SettingsViewActions.setTeamId({ teamId })),
  onSubmit: (teamId: string, settings: ITeamSettingsNotifications) =>
    // @ts-expect-error TS(2345)
    dispatch(SettingsViewActions.updateNotifications({ teamId, settings })),
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Notifications);
